import axios from 'axios'

const state = {
  articleCategory: {
    categories: [],
    expireDate: null
  }
}

const actions = {
  LOAD_ARTICLE_CATEGORY: async ({ commit }) => {
    const url = 'https://blog.beneat.co/wp-json/wp/v2/categories'
    let { data } = await axios.get(url)
    // console.log('data', data)
    if (data) {
      const icons = [
        'fal fa-clipboard-list',
        'fal fa-users-class',
        'fal fa-flask-potion',
        'fal fa-comments-alt',
        'fal fa-book',
        'fal fa-mobile',
        'fas fa-syringe',
        'fal fa-dollar-sign'
      ]
      let i = 0
      const categories = []
      for (let key in data) {
        const category = data[key]
        if (category.id > 2) {
          category.has_new_articles = false
          category.icon = (icons[i]) ? icons[i] : 'fal fa-book'
          categories.push(category)
          i += 1
        }
      }

      // ย้าย หมวดโควิดมาอยู่ลำดับที่ 2
      let findIndexCovid19 = categories.findIndex(item => item.id === 12)
      let shiftCovid = categories.splice(findIndexCovid19, 1)[0]
      categories.splice(1, 0, shiftCovid)

      commit('SET_ARTICLE_CATEGORY', categories)
    }
  }
}

const mutations = {
  SET_ARTICLE_CATEGORY: (state, categories) => {
    state.articleCategory.categories = categories
    // Set expireDate
    const today = new Date()
    today.setHours(today.getHours() + 1)
    state.articleCategory.expireDate = today.getTime()
  },
  UPDATE_HAS_NEW_ARTICLES: (state, data) => {
    console.log('UPDATE_HAS_NEW_ARTICLES', data)
    state.articleCategory.categories[data.key].has_new_articles = data.value
  },
  CLEAR_HAS_NEW_ARTICLES: (state) => {
    if (state.articleCategory.categories.length > 0) {
      for (let key in state.articleCategory.categories) {
        state.articleCategory.categories[key].has_new_articles = false
      }
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/article.js